import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { WhatsAppButton } from "../components/WhatsAppButton";
import { MobileNav } from "../components/MobileNav";
import { Hero } from "../sections/Hero";
import { Concept } from "../sections/Concept";
import { ServiceSection } from "../sections/ServiceSection";
import { Concierge } from "../sections/Concierge";
import { Destinations } from "../sections/Destinations";
import { Discretion } from "../sections/Discretion";
import { Membership } from "../sections/Membership";
import { FinalCTA } from "../sections/FinalCTA";
import { IMAGES } from "../lib/images";
import { Seo } from "../components/Seo";
import { useI18n } from "../i18n/LanguageContext";

const META = {
  en: {
    title: "VELMONTÉ — Private Office & Lifestyle Management | Anything. Anywhere.",
    desc: "A discreet private office for HNW & UHNW individuals and families. One contact for private jet charter, yacht charter, chauffeurs, luxury villas, security and concierge — worldwide, 24/7.",
  },
  es: {
    title: "VELMONTÉ — Oficina Privada y Lifestyle Management | Lo que necesites, donde sea",
    desc: "Oficina privada y discreta para clientes de alto patrimonio y sus familias. Un único contacto para jet privado, alquiler de yates, chófer, villas de lujo, seguridad y concierge — 24/7.",
  },
};

export default function Landing() {
  const { lang } = useI18n();
  const meta = META[lang === "es" ? "es" : "en"] || META.en;
  return (
    <div className="vm-grain relative">
      <Seo title={meta.title} description={meta.desc} path="/" lang={lang === "es" ? "es" : "en"} image={IMAGES.hero}
        langAlternates={[
          ["en", "https://velmonte.es/?lang=en"],
          ["es", "https://velmonte.es/?lang=es"],
          ["ar", "https://velmonte.es/?lang=ar"],
          ["de", "https://velmonte.es/?lang=de"],
          ["fr", "https://velmonte.es/?lang=fr"],
          ["x-default", "https://velmonte.es/"],
        ]}
        jsonLd={[{
          "@context": "https://schema.org", "@type": "WebSite",
          name: "VELMONTÉ", url: "https://velmonte.es/",
          inLanguage: ["en", "es", "ar", "de", "fr"],
        }]} />
      <Header />
      <main>
        <Hero />
        <Concept />
        <ServiceSection id="aviation" ns="aviation" image={IMAGES.aviation} category="aviation" />
        <ServiceSection id="yachts" ns="yachts" image={IMAGES.yacht} category="yacht" reverse />
        <ServiceSection id="chauffeur" ns="chauffeur" image={IMAGES.chauffeur} category="chauffeur" />
        <ServiceSection id="villas" ns="villas" image={IMAGES.villa} category="villa" reverse />
        <Concierge />
        <Destinations />
        <Discretion />
        <Membership />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
      <MobileNav />
    </div>
  );
}
